var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-button",class:_vm.isColourful ? '' : 'text-button-gray',on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }